export default __webpack_public_path__ + "static/media/ruleswalkover.352407fb.png";